/* Bloque de packs editable desde la sección nativa de Shopify. */
(() => {
  'use strict';
  if (window.CampanitaPacksV1) { window.CampanitaPacksV1.init(); return; }
  const instances = new Map();
  function init() {
    document.querySelectorAll('template[data-cp-source]').forEach(source => {
      const id = source.dataset.sectionId;
      if (instances.get(id)?.source === source) return;
      instances.get(id)?.cleanup();
      let root, delivery, cta, stackParent, waiter, selectionTimer, disposed = false, original;
      const status = text => { if(root) root.querySelector('[role="status"]').textContent = text; };
      function cleanup() {
        disposed = true; clearInterval(waiter); clearInterval(selectionTimer);
        root?.remove(); delivery?.remove();
        stackParent?.classList.remove('cp-purchase-stack');
        if (cta && original) {
          cta.classList.remove('cp-packs-cta','cp-packs-cta--green');
          cta.style.setProperty('background', original.background, original.backgroundPriority);
          cta.style.setProperty('border-radius', original.radius, original.radiusPriority);
          cta.style.setProperty('font-size', original.fontSize, original.fontSizePriority);
          cta.style.setProperty('color', original.color, original.colorPriority);
          if(original.titleNode?.isConnected) original.titleNode.textContent = original.title;
          if(original.subtitle?.isConnected) original.subtitle.textContent = original.subtitleText;
        }
      }
      function selectOffer(card) {
        clearInterval(selectionTimer);
        root.querySelectorAll('[data-cp-offer]').forEach(c => c.setAttribute('aria-pressed', String(c === card)));
        const index = Number(card.dataset.cpOffer);
        const unselect = () => root.querySelectorAll('[data-cp-offer]').forEach(c=>c.setAttribute('aria-pressed','false'));
        if(!Number.isInteger(index) || index < 0) { unselect(); status('Revisa el precio del pack antes de continuar.'); return; }
        status('Abriendo tu pack…'); cta.click();
        let attempts = 0, lastClick = 0, selectedAt = 0;
        selectionTimer = setInterval(() => {
          if (disposed || !root.isConnected) { clearInterval(selectionTimer); return; }
          const modal = document.getElementById('_rsi-cod-form-modal');
          const offers = modal ? Array.from(modal.querySelectorAll('._rsi-quantity-offers-offer-container')).filter(e => e.getClientRects().length) : [];
          const offer = offers.find(e => Number(e.dataset.offerPos) === index);
          if(modal && !offers.length && new Set(Array.from(modal.querySelectorAll('a[href*="/products/"]')).filter(a=>a.getClientRects().length).map(a=>a.getAttribute('href').split('?')[0])).size>1){unselect();status('Tu formulario incluye varios productos. Revisa el resumen antes de completar la compra.');clearInterval(selectionTimer);return;}
          if (offer) {
            {
              if (offer.classList.contains('_rsi-quantity-offers-selected')) {
                if (!selectedAt) selectedAt = Date.now();
                if (Date.now() - selectedAt > 750) { status('Pack seleccionado. Revisa el total y completa tus datos en el formulario.'); clearInterval(selectionTimer); }
              } else {
                selectedAt = 0;
                if (Date.now() - lastClick > 350) { (offer.querySelector('._rsi-quantity-offers-offer') || offer).click(); lastClick = Date.now(); }
              }
            }
          }
          if (++attempts >= 100) { unselect(); status('Revisa los productos y el total directamente en el formulario.'); clearInterval(selectionTimer); }
        }, 150);
      }
      function mount() {
        if (disposed || !source.isConnected) { clearInterval(waiter); return; }
        cta = document.querySelector('#MainContent ._rsi-buy-now-button-product');
        if (!cta) return;
        const fragment = source.content.cloneNode(true);
        root = fragment.querySelector('.cp-packs'); delivery = fragment.querySelector('.cp-delivery');
        if (!root || !delivery) { clearInterval(waiter); return; }
        root.dataset.cpMounted = id; delivery.dataset.cpMounted = id;
        stackParent=cta.parentElement;stackParent.classList.add('cp-purchase-stack');
        cta.before(root); cta.after(delivery);
        const titleNode=Array.from(cta.querySelector('span')?.childNodes || []).find(n=>n.nodeType===3);
        const subtitle=cta.querySelector('._rsi-buy-now-button-subtitle');
        original={color:cta.style.getPropertyValue('color'),colorPriority:cta.style.getPropertyPriority('color'),background:cta.style.getPropertyValue('background'),backgroundPriority:cta.style.getPropertyPriority('background'),radius:cta.style.getPropertyValue('border-radius'),radiusPriority:cta.style.getPropertyPriority('border-radius'),fontSize:cta.style.getPropertyValue('font-size'),fontSizePriority:cta.style.getPropertyPriority('font-size'),titleNode,title:titleNode?.textContent,subtitle,subtitleText:subtitle?.textContent};
        cta.classList.add('cp-packs-cta'); cta.style.setProperty('background', source.dataset.primary || '#3484f6', 'important'); cta.style.setProperty('border-radius','10px','important');
        cta.style.setProperty('font-size','20px','important');
        if(source.dataset.palette==='green'){cta.classList.add('cp-packs-cta--green');cta.style.setProperty('color','#042f2e','important');}
        if(source.dataset.buttonTitle && titleNode) titleNode.textContent=source.dataset.buttonTitle;
        if(source.dataset.buttonSubtitle && subtitle) subtitle.textContent=source.dataset.buttonSubtitle;
        root.addEventListener('click',event=>{const card=event.target.closest('[data-cp-offer]');if(card&&root.contains(card))selectOffer(card);});
        clearInterval(waiter);
      }
      instances.set(id,{source,cleanup,get root(){return root;}});
      mount(); if (!root) waiter=setInterval(mount,250);
      setTimeout(()=>clearInterval(waiter),15000);
    });
  }
  window.CampanitaPacksV1={init};
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',init,{once:true}); else init();
  document.addEventListener('shopify:section:load',init);
  document.addEventListener('shopify:section:unload',event=>{const id=event.detail?.sectionId;instances.get(id)?.cleanup();instances.delete(id);});
  document.addEventListener('shopify:section:select',event=>instances.get(event.detail?.sectionId)?.root?.scrollIntoView({block:'center',behavior:'smooth'}));
})();
